import React, { Fragment, useState } from 'react';
import { SvgIcon } from 'core/icons';
import { Translate } from 'core/translate';

const Disclaimer = ({ disclaimers }) => {
  const [isOpen, setIsOpen] = useState(true);

  if (disclaimers.length === 0) {
    return null;
  }

  const onClick = () => {
    setIsOpen(!isOpen);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const disclaimerSlots = disclaimers.map((disclaimer, index) => (
    <div className="carousel__disclaimer-text" key={index}>
      {disclaimer}
    </div>
  ));

  return (
    <Fragment>
      <button className="carousel__disclaimer-button" onClick={onClick}>
        <SvgIcon
          name="feature-availability"
          className="carousel__disclaimer-icon"
        />
      </button>
      {isOpen && (
        <div className="carousel__disclaimer">
          {disclaimerSlots}
          <button
            as="a"
            className="carousel__disclaimer-close-link"
            onClick={onClose}>
            <Translate value={'byo.page.general.ok'} />
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default Disclaimer;
